// CommonJS packages that set __esModule (transpiled ESM) give a "type": "module" project's default
// import the whole module.exports under Vite 8, not module.exports.default as Vite 7 did. Use the
// value itself when it is already a Vue plugin (a function or an object with install), else .default.
export function cjsDefault<T>(mod: T): T {
  const value = mod as any
  if (typeof value === 'function' || typeof value?.install === 'function') {
    return mod
  }
  return value?.default ?? mod
}
